(() => {
  const inputValues = window.WeakMap ? new WeakMap() : Map();
  let lastFilterURL = window.localStorage.getItem('swinger.last-filter-url');
  try {
    const filterWorkerBroadcastChannel = new BroadcastChannel('filter-worker');
    filterWorkerBroadcastChannel.onmessage = (e) => {
      lastFilterURL = e.data;
      window.localStorage.setItem('swinger.last-filter-url', lastFilterURL);
    };
  } catch (e) {
    // noop
  }

  window.swinger.eventHub.register('focus', '.swinger-input__input', (e) => {
    const input = window.swinger.eventHub.getTarget(e);
    const wrapper = window.swinger.eventHub.getTarget(e).closest('.swinger-input');

    if (input.type !== 'checkbox' && input.type !== 'radio') {
      wrapper.classList.add('swinger-input--was-touched');
      wrapper.removeAttribute('data-validation-message');
    }

    wrapper.classList.add('swinger-input--is-focused');
  });

  window.swinger.eventHub.register('input reset', '.swinger-input__input', (e) => {
    const input = window.swinger.eventHub.getTarget(e);

    if (input.checkValidity()) {
      input.removeAttribute('aria-invalid');
      const previousDescribedBy = input.getAttribute('data-aria-describedby');
      if (previousDescribedBy) {
        input.setAttribute('aria-describedby', previousDescribedBy);
      } else {
        input.removeAttribute('aria-describedby');
      }
    } else {
      input.setAttribute('aria-invalid', 'true');
      const previousDescribedBy = input.getAttribute('aria-describedby') || '';
      if (previousDescribedBy && !input.getAttribute('data-aria-describedby')) {
        input.setAttribute('data-aria-describedby', previousDescribedBy);
      }
      input.setAttribute('aria-describedby', `${previousDescribedBy} ${window.swinger.a11y.createDescription(input.validationMessage)}`);
    }
  });

  window.swinger.eventHub.register('blur reset', '.swinger-input__input', (e) => {
    const input = window.swinger.eventHub.getTarget(e);
    const wrapper = input.closest('.swinger-input');

    wrapper.classList.remove('swinger-input--is-focused');

    if (input.checkValidity()) {
      wrapper.removeAttribute('data-validation-message');
    } else {
      wrapper.setAttribute('data-validation-message', input.validationMessage);
    }
  });

  window.swinger.eventHub.register('input change blur keyup reset', '.swinger-input__input', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const wrapper = elem.closest('.swinger-input');
    const { value } = window.swinger.$('input:not([type="email"]):not([type="password"]):not([type="radio"]):not([type="checkbox"]), input[type="radio"]:checked, input[type="checkbox"]:checked', wrapper)[0] || { value: '' };

    if (
      ['email', 'password'].indexOf(elem.type) > -1
      || inputValues[elem] === value
    ) {
      return;
    }

    inputValues[elem] = value;
  });

  window.swinger.eventHub.register('input change reset animationend', '.swinger-input__input', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const wrapper = elem.closest('.swinger-input');

    window.setTimeout(() => {
      const isFilledClass = 'swinger-input--is-filled';
      if (elem.value && !wrapper.classList.contains(isFilledClass)) {
        wrapper.classList.add(isFilledClass);
      }
      if (!elem.value && wrapper.classList.contains(isFilledClass)) {
        wrapper.classList.remove(isFilledClass);
      }

      const isFocusedClass = 'swinger-input--is-focused';
      if (document.activeElement && !wrapper.classList.contains(isFocusedClass)) {
        wrapper.classList.add(isFocusedClass);
      }
      if (!document.activeElement && wrapper.classList.contains(isFocusedClass)) {
        wrapper.classList.remove(isFocusedClass);
      }
    });
  });

  window.swinger.eventHub.register('keyup click', '.swinger-input__password-toggle', (e) => {
    if (e.type === 'keyup' && e.key !== ' ') {
      return;
    }

    const button = window.swinger.eventHub.getTarget(e);
    const elemId = button.getAttribute('aria-controls');
    const elem = document.getElementById(elemId);

    if (elem.type === 'password') {
      elem.type = 'text';
      button.setAttribute('aria-checked', 'true');

      window.swinger.i18n()
        .then((i18n) => {
          const password = elem.value || i18n('ui.shared.empty');

          window.swinger.a11y.notify(i18n('ui.input.password.notification.is-shown', {
            password,
          }));
        })
        .catch(console.info);
    } else {
      elem.type = 'password';
      button.setAttribute('aria-checked', 'false');

      window.swinger.i18n()
        .then((i18n) => {
          window.swinger.a11y.notify(i18n('ui.input.password.notification.is-hidden'));
        })
        .catch(console.info);
    }
  });

  window.swinger.eventHub.register('keyup click', '.swinger-input__insert-filter-url', (e) => {
    if (e.type === 'keyup' && e.key !== ' ') {
      return;
    }

    if (!lastFilterURL) {
      // eslint-disable-next-line no-alert
      window.alert('Please run a facetted search first');
      return;
    }

    const button = window.swinger.eventHub.getTarget(e);
    const elemId = button.getAttribute('aria-controls');
    const elem = document.getElementById(elemId);

    if (elem.value === lastFilterURL) {
      return;
    }

    elem.value = lastFilterURL;

    window.swinger.eventHub.trigger(elem, 'change');
    window.swinger.eventHub.trigger(elem, 'input');
  });

  /* Next: Search input specific behavior */
  window.swinger.eventHub.register('keydown', '.swinger-input__input[type="search"]', (e) => {
    if (e.key !== 'Escape' && e.key !== 'Esc') {
      return;
    }

    e.target.value = '';
  });
})();
